module.exports = __webpack_public_path__ + "img/coke-zero_logo.0c96eb6c.jpg";